// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__273MG","amount":"Amount_amount__1SP3x","tip":"Amount_tip__1k83-","tipHeader":"Amount_tipHeader__H4lYb","tipsWrap":"Amount_tipsWrap__3f_AJ"};